import { Fragment } from "react";
import { CommonGrid2 } from "../../../common-components/StyledComponents";
import { Box, IconButton, Typography, useMediaQuery } from "@mui/material";
import DeleteIco from "../../../../assets/icons/DeleteIco";
import { GetFileIcon } from "../../../../utils/constants";
import { formatFileSize } from "../../../common-components/CoverSheetFunction";

export default function CommonFileData({ handleRemoveFile, item, values }) {
  const lg = useMediaQuery("(min-width:767px)");

  return (
    <Fragment>
      {values?.map((file, index) => {
        return (
          <CommonGrid2
            item
            key={index}
            sx={{
              backgroundColor: "#FFFFFF",
              border: "1px solid #EAECF0",
              borderRadius: "8px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: {
                xs: "80%",
                sm: "60%",
                md: "75%",
                lg: "60%",
              },
              margin: "auto",
              padding: "10px",
              minWidth: 0,
              marginBottom: "1rem",
            }}
          >
            <Box
              display={"flex"}
              alignItems={"center"}
              gap={2}
              flex={1}
              minWidth={0}
            >
              <Box display="flex" alignItems="center">
                <GetFileIcon file={file} width={"24px"} />
              </Box>

              <Box
                display={"flex"}
                flexDirection={"column"}
                minWidth={0}
                alignItems={"baseline"}
              >
                <Typography
                  fontSize={"13px"}
                  fontWeight={600}
                  lineHeight={"16px"}
                  color={"#344054"}
                  overflow={"hidden"}
                  textOverflow={"ellipsis"}
                  whiteSpace={"nowrap"}
                  width={"100%"}
                >
                  {file?.file?.[0]?.name || file.name}
                </Typography>

                <Typography
                  variant={lg ? "p" : "subtitle2"}
                  color="#7F56D9"
                  fontWeight={600}
                  sx={{
                    wordBreak: "break-all",
                  }}
                >
                  {file?.file?.[0]?.file_name || file?.file_name}
                </Typography>
                <Typography
                  variant={lg ? "p" : "subtitle2"}
                  color="#475467"
                  fontWeight={500}
                >
                  {formatFileSize(file?.file?.[0]?.size || file?.size)}
                </Typography>
              </Box>
            </Box>

            {/* Delete Icon */}
            <IconButton onClick={() => handleRemoveFile(index, item)}>
              <DeleteIco stroke="#D80027" size="18px" />
            </IconButton>
          </CommonGrid2>
        );
      })}
    </Fragment>
  );
}
